var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcWarningEpDsk(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "31px",
    height: "27px",
    viewBox: "0 0 31 27",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icWarningEpDsk") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M30.2795103,23.6785591 L18.1699596,1.42626967 C17.8165327,0.863883107 17.1819579,0.52 16.4974539,0.52 C15.8129499,0.52 15.1783752,0.863823374 14.8249483,1.42626967 L0.840522145,23.6785591 C0.476822974,24.2573125 0.466052697,24.9791863 0.812444718,25.5676164 C1.15883674,26.1561063 1.80860193,26.52 2.51296558,26.52 L28.6070046,26.52 C29.3113682,26.52 29.9611334,26.1560466 30.3075254,25.5676164 C30.6539174,24.9791265 30.6432094,24.2573125 30.2795103,23.6785591 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop-Manage-Photos",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icWarningEpDsk"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FF0000",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0702892,8.52 C16.8772237,8.52 17.56,8.94805722 17.56,9.70677363 C17.56,12.0219174 17.2703392,15.3488595 17.2703392,17.6640032 C17.2703392,18.2671533 16.5668595,18.52 16.0702892,18.52 C15.4082789,18.52 14.8495982,18.2670945 14.8495982,17.6640032 C14.8495982,15.3488595 14.56,12.0219174 14.56,9.70677363 C14.56,8.94805722 15.2220103,8.52 16.0702892,8.52 Z M16.0698101,22.52 C15.2071123,22.52 14.56,21.8187044 14.56,21.02 C14.56,20.2018021 15.207053,19.52 16.0698101,19.52 C16.8737065,19.52 17.56,20.2018021 17.56,21.02 C17.56,21.8187044 16.8737065,22.52 16.0698101,22.52 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcWarningEpDsk);
export default __webpack_public_path__ + "static/media/icWarningEpDsk.8c09f93c6ba2d48082638de44c788692.svg";
export { ForwardRef as ReactComponent };